const listStyleImage = {
  name: "list-style-image",
  path: "/list-style-image",
  title: "list-style-image",
  description: "Utilities for setting custom images as list item markers.",
  value: {
    "list-style-image": {
      "list-image-none": "none",
      "list-image-[url]": "url('<image-url>')"
    }
  },
  exampleData: [
    {
      example: {
        code: `
<ul class="list-image-none">
  <li>List item with no marker</li>
</ul>
<ul class="list-image-[url(...)]">
  <li>List item with custom SVG marker</li>
  <li>Another item</li>
</ul>
        `
      }
    }
  ],
  htmlData: [
    {
      data: `
      <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
        Use <code class="text-color-gray-800 dark:text-color-white font-semibold">list-image-none</code> to remove list markers, or <code class="text-color-gray-800 dark:text-color-white font-semibold">list-image-[url(...)]</code> to set a custom image as the marker.
      </p>
      <div class="space-y-6">
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">list-image-none</small>
          <ul class="*:py-2 list-image-none pl-6">
            <li>List item with no marker</li>
            <li>Another item</li>
          </ul>
        </div>
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">list-image-[url]</small>
          <ul class="*:py-2 list-image-[url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxNCAxMiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiBmaWxsPSIjMzhiZGY4Ij48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMy42ODUuMTUzYS43NTIuNzUyIDAgMCAxIC4xNDMgMS4wNTJsLTggMTAuNWEuNzUuNzUgMCAwIDEtMS4xMjcuMDc1bC00LjUtNC41YS43NS43NSAwIDAgMSAxLjA2LTEuMDZsMy44OTQgMy44OTMgNy40OC05LjgxN2EuNzUuNzUgMCAwIDEgMS4wNS0uMTQzWiIgLz48L3N2Zz4=)] pl-6">
            <li>List item with custom SVG marker</li>
            <li>Another item</li>
          </ul>
        </div>
      </div>
      `
    }
  ]
}
export default listStyleImage;

<div class="sr-only">
        <div>
          <small class="mb-3 *:py-2 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">list-image-none</small>
          <ul class="list-image-none pl-6">
            <li>List item with no marker</li>
            <li>Another item</li>
          </ul>
        </div>
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">list-image-[url]</small>
          <ul class="list-image-[url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxNCAxMiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiBmaWxsPSIjMzhiZGY4Ij48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMy42ODUuMTUzYS43NTIuNzUyIDAgMCAxIC4xNDMgMS4wNTJsLTggMTAuNWEuNzUuNzUgMCAwIDEtMS4xMjcuMDc1bC00LjUtNC41YS43NS43NSAwIDAgMSAxLjA2LTEuMDZsMy44OTQgMy44OTMgNy40OC05LjgxN2EuNzUuNzUgMCAwIDEgMS4wNS0uMTQzWiIgLz48L3N2Zz4=)] pl-6">
            <li>List item with custom SVG marker</li>
            <li>Another item</li>
          </ul>
        </div>
      </div>